import { SidebarItem } from '@backstage/core-components';
import CreateComponentIcon from '@material-ui/icons/AddCircleOutline'
import BulletedListIcon from '@material-ui/icons/FormatListBulleted'
import { permissionApiRef } from '@backstage/plugin-permission-react';
import { AuthorizeResult } from '@backstage/plugin-permission-common'
import { identityApiRef, useApi } from '@backstage/core-plugin-api';
import useAsync from 'react-use/lib/useAsync';
import { 
  templateStepReadPermission,
  templateParameterReadPermission,
  actionExecutePermission
} from '@backstage/plugin-scaffolder-common/alpha'

export const ScaffolderSidebarItem = () => {
  const permissionsApi = useApi(permissionApiRef);
  const identityApi = useApi(identityApiRef);
  const { loading, value: allowed } = useAsync(async () => {

    const { userEntityRef } = await identityApi.getBackstageIdentity()
    
    const promises = [ templateParameterReadPermission, templateStepReadPermission, actionExecutePermission ]
      .map((permission) => permissionsApi.authorize({ permission, resourceRef: userEntityRef}))

    return Promise.all(promises).then((results) => {
      for (let policyDecision of results) {
        if (policyDecision.result === AuthorizeResult.DENY) {
          return false
        }
      }
      return true
    });
  });
  
  if (!loading && allowed) {
    return (
      <>
        <SidebarItem
        text="Create..."
        to="create"
        icon={CreateComponentIcon}
        />
        <SidebarItem
          text="Scaffolder Logs"
          to="create/tasks"
          icon={BulletedListIcon}
        />
      </>
    );
  }
  return null;
};
